import { ChangeDetectionStrategy, Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { BaseWalkthroughStepComponent } from '../base-walkthrough-step/base-walkthrough-step.component';

@Component({
  selector: 'hub-search-walkthrough',
  templateUrl: './search-walkthrough.component.html',
  styleUrls: ['./search-walkthrough.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchWalkthroughComponent extends BaseWalkthroughStepComponent {
  constructor(public el: ElementRef, public auth: AuthService) {
    super(el);
  }
}
